/* unplugin-vue-components disabled */import { ElTable as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElInputNumber as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElTableColumn as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
import { apiUsdkGetCurrencyList, apiUsdkbatchAddGoods } from '@/api/usdk';
import { file2Xce } from '@/utils/util';
const downloadUrl = 'https://cdnstatic.yingxiong.com/open/online/goods_template.xlsx';
export default /*#__PURE__*/_defineComponent({
  __name: 'addGameGoods',
  props: {
    gameInfo: {
      type: Object
    }
  },
  emits: ['onActive'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const tableData = ref([]);
    const currencyOptions = ref([]);
    const currency = ref('RMB');
    const Input = ref();
    const emits = __emit;
    const handleAddItem = () => {
      const lastRow = tableData.value.length > 0 && tableData.value[tableData.value.length - 1];
      if (lastRow && (!lastRow.goods || !lastRow.name || !lastRow.price || !lastRow.desc)) {
        ElMessage.warning('请填写完整商品信息');
        return;
      }
      tableData.value.push({
        goods: '',
        name: '',
        price: undefined,
        desc: ''
      });
    };
    const handleDelItem = index => {
      tableData.value.splice(index, 1);
    };
    const getCurrencyList = async () => {
      const res = await apiUsdkGetCurrencyList();
      if (res.code === 0) {
        currencyOptions.value = res.data;
      }
    };
    const handleDownload = () => {
      window.open(downloadUrl);
    };
    const handlePatchInputClick = () => {
      Input.value.dispatchEvent(new MouseEvent('click'));
    };
    const fnGetExtension = file => {
      const fileName = file.name;
      const patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
      const fileExtension = fileName.match(patternFileExtension);
      return fileExtension;
    };
    const handleFileChange = e => {
      let file = e.target.files[0];
      const accept = '.xls,.xlsx';
      if (!accept.includes(fnGetExtension(file)[1])) {
        ElMessage({
          type: 'warning',
          message: `请上传符合以下格式的文件：${accept}`
        });
      } else {
        try {
          file2Xce(file).then(data => {
            if (data.length) {
              const arr = [];
              data.forEach(item => {
                const obj = {
                  goods: item['游戏商品ID'] || '',
                  name: item['商品名称'] || '',
                  price: item['商品金额'] || '',
                  desc: item['商品描述'] || ''
                };
                arr.push(obj);
              });
              tableData.value = tableData.value.concat(arr);
            }
          });
        } catch (e) {
          ElMessage({
            type: 'warning',
            message: `上传文件解析失败`
          });
        }
      }
      Input.value.value = '';
    };
    const getCurrencyName = currency => {
      let c = currencyOptions.value.find(item => item.currency === currency);
      return c && c.desc || currency;
    };
    const handleConfirm = () => {
      let data = JSON.parse(JSON.stringify(tableData.value));
      if (data.length <= 0) {
        ElMessage.warning('请添加商品信息');
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        const current = data[i];
        if (!current.goods) {
          ElMessage.warning('商品ID必填');
          return;
        }
        if (!current.name) {
          ElMessage.warning('商品名称必填');
          return;
        }
        if (!current.price) {
          ElMessage.warning('商品金额必填');
          return;
        }
        if (current.price <= 0) {
          ElMessage.warning('商品金额必须大于0');
          return;
        }
        data[i].currency = currency.value;
      }
      ElMessageBox.confirm(`您正在保存商品，商品全局币种选择为【${getCurrencyName(currency.value)}】。请务必确保商品ID及币种均正确后再进行保存。`, '提示', {
        confirmButtonText: '保存商品',
        cancelButtonText: '返回检查',
        type: 'warning'
      }).then(() => {
        apiUsdkbatchAddGoods({
          gid: props.gameInfo && props.gameInfo.Id,
          goodsList: JSON.stringify(data)
        }).then(res => {
          if (res.code === 0) {
            emits('onActive', 'goodsConf');
          }
        });
      }).catch(() => {
        console.log('ss');
      });
    };
    onMounted(() => {
      getCurrencyList();
    });
    __expose({
      handleConfirm
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_table_column = __unplugin_components_5;
      const _component_el_input_number = __unplugin_components_6;
      const _component_el_table = __unplugin_components_7;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card_pane, {
        name: "addGameGoods"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handlePatchInputClick
        }, {
          default: _withCtx(() => [_createTextVNode("批量上传商品")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: handleDownload
        }, {
          default: _withCtx(() => [_createTextVNode("文件模板")]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          label: "币种选择",
          class: "marginL20"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(currency),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currency) ? currency.value = $event : null),
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.currency,
                label: item.desc,
                value: item.currency
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_table, {
          ref: "tableRef",
          data: _unref(tableData),
          style: {
            "width": "100%"
          },
          class: "marginT20"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            property: "goods",
            label: "游戏商品ID",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.goods,
              "onUpdate:modelValue": $event => scope.row.goods = $event,
              maxlength: "300"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "name",
            label: "商品名称",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.name,
              "onUpdate:modelValue": $event => scope.row.name = $event,
              maxlength: "300"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "desc",
            label: "商品描述",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.desc,
              "onUpdate:modelValue": $event => scope.row.desc = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "price",
            label: "商品金额"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.price,
              "onUpdate:modelValue": $event => scope.row.price = $event,
              min: 0
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              link: "",
              type: "danger",
              onClick: $event => handleDelItem(scope.$index)
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_button, {
          class: "mt-4 marginT10 width100",
          onClick: handleAddItem
        }, {
          default: _withCtx(() => [_createTextVNode("添加")]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("input", {
        type: "file",
        accept: ".xls,.xlsx",
        ref_key: "Input",
        ref: Input,
        multiple: false,
        onChange: handleFileChange,
        style: {
          "display": "none"
        }
      }, null, 544)], 64);
    };
  }
});